// @flow
import React from "react";
import CountUp from "react-countup";
import _ from "lodash";
import I18n from "../../../i18n/I18n";
import { LocaleLink } from "../../common/";
import styles from "./StockRequestsSummary.scss";

class StockRequestsSummary extends React.Component {
  componentDidMount = () => {
    const { warehouses, getStocksCount } = this.props;
    if (warehouses && !_.isEmpty(warehouses)) {
      this.props.getStocksCount(warehouses[0].id_warehouse);
    }
  };
  render() {
    const { warehouses, idWarehouse, counts, getStocksCount } = this.props;
    const warehouseList =
      warehouses && !_.isEmpty(warehouses)
        ? warehouses.map((warehouse, index) => {
            return (
              <a
                className={`${styles.daybtn} ${
                  idWarehouse === warehouse.id_warehouse ? styles.selected : ""
                }`}
                onClick={() => getStocksCount(warehouse.id_warehouse)}
              >
                {warehouse.code}
              </a>
            );
          })
        : "";
    return (
      <div>
        <div className={styles.graphTitleWrapper}>
          <h4 className={styles.graphTitle}>
            {I18n.getText("menu.stock-requests")}
          </h4>
          <div className={styles.daysSwitch}>{warehouseList}</div>
        </div>
        {counts ? (
          <div className={styles.summaryCtr}>
            <LocaleLink
              to={`/stock-request?status=1&id_warehouse=${idWarehouse}`}
              className={styles.summaryItem}
            >
              <h3 className={styles.summaryTitle}>
                {I18n.getText("stock-request.pending")}
              </h3>
              <div className={styles.count}>
                <CountUp start={0} end={Number(counts.pending)} />
              </div>
            </LocaleLink>

            <LocaleLink
              to={`/stock-request?status=2&id_warehouse=${idWarehouse}`}
              className={styles.summaryItem}
            >
              <h3 className={styles.summaryTitle}>
                {I18n.getText("stock-request.picklist")}
              </h3>
              <div className={styles.count}>
                <CountUp start={0} end={Number(counts.picklist)} />
              </div>
            </LocaleLink>

            <LocaleLink
              to={`/stock-request?status=3&id_warehouse=${idWarehouse}`}
              className={styles.summaryItem}
            >
              <h3 className={styles.summaryTitle}>
                {I18n.getText("stock-request.readyforpickup")}
              </h3>
              <div className={styles.count}>
                <CountUp start={0} end={Number(counts.readyforpickup)} />
              </div>
            </LocaleLink>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}
export default StockRequestsSummary;



// WEBPACK FOOTER //
// ./src/components/dashboard/StockRequestsSummary/StockRequestsSummary.js